import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Form } from 'semantic-ui-react'
import { saveComment } from '../redux/actions'
import { withRouter } from 'react-router-dom'

const HOME_PATH = '/inCyberNotes'

class SubmitComment extends Component {
  state = {
    commentBody: ''
  }

  handleChange = e => {
    /*this.setState(() => ({
      commentBody: e.target.value
    }))*/

    // if not work:
    this.setState({ commentBody: e.target.value })
  }
  backHome = () => {
    this.props.history.push(HOME_PATH)
  }

  handleSubmit = e => {
    e.preventDefault()
    const comment = {
      commentBody: this.state.commentBody,
      uid: this.props.uid
    }
    this.props.saveComment(this.props.id, comment)
    this.setState(() => ({
      commentBody: ''
    }))
  }
  formLoading = () => {
    return (
      <Form loading={false} onSubmit={this.handleSubmit}>
        {/*<Form.Input label="Title" placeholder="Title" />*/}
        <div className="field">
          <label>Write a comment</label>
          <textarea
            onChange={this.handleChange.bind(this)}
            value={this.state.commentBody}
            type="text"
            name="body"
            placeholder="body"
            rows="2"
          />
        </div>
        <Button>Submit</Button>
        <Button
          onClick={this.backHome}
          type='button'
          className="ui violet basic button">
          Back
        </Button>
      </Form>
    )
  }
  render() {
    return (
      <div>
        <h2>{this.formLoading()}</h2>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    uid: state.user.uid
  }
}
export default withRouter(connect(mapStateToProps, { saveComment })(SubmitComment))



// WEBPACK FOOTER //
// ./src/components/SubmitComment.js